import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Glossary() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/content/glossary").then(r => setItems(r.data || [])); }, []);

  const filtered = items.filter(i =>
    !q || i.term.toLowerCase().includes(q.toLowerCase()) || i.definition.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-7" data-testid="glossary-page">
      <header>
        <div className="overline">Brokerage</div>
        <h1 className="font-heading text-5xl mt-2">GA Real Estate Law Glossary</h1>
        <p className="text-sm text-[#050303]/60 mt-2">Quick reference for the language of GA real estate.</p>
      </header>

      <div className="flex items-center gap-3 max-w-2xl">
        <input
          data-testid="glossary-search"
          value={q} onChange={e => setQ(e.target.value)}
          placeholder="Search terms (filters CORE list + opens GSCCCA for full GA law lookup)…"
          className="flex-1 px-4 py-3 border border-[#d1cece] rounded-lg outline-none focus:border-[#bf858e]"
        />
        <a
          href={q ? `https://www.gsccca.org/glossary?search=${encodeURIComponent(q)}` : "https://www.gsccca.org/glossary"}
          target="_blank" rel="noopener noreferrer"
          data-testid="glossary-gsccca-link"
          className="bg-[#050303] text-white pill-btn hover:bg-[#bf858e] whitespace-nowrap"
        >
          Search GSCCCA →
        </a>
      </div>
      <p className="text-xs text-[#050303]/55">Tip: typing filters CORE's curated glossary instantly. Click <span className="font-semibold">Search GSCCCA</span> to open the official Georgia Superior Court Clerks' Cooperative Authority glossary for the same term.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map(t => (
          <div key={t.id} className="core-card p-5" data-testid={`term-${t.id}`}>
            <div className="font-heading text-xl">{t.term}</div>
            <p className="text-sm text-[#050303]/75 mt-2 leading-relaxed">{t.definition}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
